import React, { useEffect, useState } from "react";
import "../styles/Services.css";

// Ensure this matches your backend URL
// const API_URL = "http://localhost:5000";
const API_URL = "https://backend.afrivisionconsultants.com";
// const API = "https://backend.afrivisionconsultants.com";

// 1. Add the exact same slugify function here
const slugify = (text) => {
  if (!text) return "";
  return text
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");
};

const Services = () => {
  const [services, setServices] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  
  // State to track which service is selected for the pop-up modal
  const [selectedService, setSelectedService] = useState(null);

  useEffect(() => {
    const fetchServices = async () => {
      try {
        const res = await fetch(`${API_URL}/public/services`);
        if (!res.ok) throw new Error("Failed to load services");
        const data = await res.json();
        setServices(data);
      } catch (err) {
        console.error("Error fetching services:", err);
        setError("Failed to load services. Please try again later.");
      } finally {
        setLoading(false);
      }
    };

    fetchServices();
  }, []);

  if (loading) return <div className="loading-spinner">Loading Services...</div>;
  if (error) return <div className="error-message">{error}</div>;

  return (
    <section className="services-section" id="our-services">
      <h1 className="services-main-title text-center">Our Services</h1>
      
      {services.length === 0 ? (
        <p className="text-center">No services available at the moment.</p>
      ) : (
        <div className="services-container">
          {/* 1. Loop through the Groups */}
          {services.map((group) => (
            <div 
              className="service-group" 
              id={slugify(group.name || group.title)} // <-- Assign the target ID here
              key={group.id}
            >
              
              <h2 className="service-group-title">{group.name || group.title}</h2>

              {/* 2. Loop through the Cards inside this Group */}
              <div className="service-cards-grid">
                {group.ServiceItems && group.ServiceItems.map((item) => (
                  <div key={item.id} className="service-card">
                    
                    {/* Attach API_URL to the image so it loads from the backend */}
                    <img 
                      src={item.image ? (item.image.startsWith("http") ? item.image : `${API_URL}${item.image}`) : "https://via.placeholder.com/600x400?text=No+Image"} 
                      alt={item.title} 
                      className="service-card-img"
                      onError={(e) => { e.target.src = "https://via.placeholder.com/600x400?text=Image+Error"; }}
                    />
                    
                    <div className="service-card-content">
                      <h3 className="service-card-title">{item.title}</h3>
                      <p className="service-card-desc">
                        {item.desc}
                      </p>
                      
                      {/* Button to open your existing Modal */}
                      <button 
                        className="service-card-btn" 
                        onClick={() => setSelectedService(item)}
                      >
                        Read More
                      </button>
                    </div>

                  </div>
                ))}
              </div>
              
              {(!group.ServiceItems || group.ServiceItems.length === 0) && (
                <p className="empty-group-text">More services coming soon to this category.</p>
              )}

            </div>
          ))}
        </div>
      )}

      {/* --- MODAL --- */}
      {selectedService && (
        <div className="service-modal-overlay" onClick={() => setSelectedService(null)}>
          {/* Prevent closing when clicking inside the modal content */}
          <div className="service-modal-content" onClick={(e) => e.stopPropagation()}>
            
            <button className="service-modal-close" onClick={() => setSelectedService(null)}>
              &times;
            </button>
            
            <div className="service-modal-image-wrapper">
              <img
                src={
                  selectedService.image 
                    ? (selectedService.image.startsWith("http") ? selectedService.image : `${API_URL}${selectedService.image}`) 
                    : "https://via.placeholder.com/600x400?text=No+Image"
                }
                alt={selectedService.title}
                className="service-modal-image"
                onError={(e) => { e.target.src = "https://via.placeholder.com/600x400?text=Image+Error"; }}
              />
            </div>
            
            <div className="service-modal-body">
              <h2 className="service-modal-title">{selectedService.title}</h2>
              
              {/* whiteSpace: "pre-wrap" ensures paragraphs and line breaks are preserved */}
              <div className="service-modal-text">
                {selectedService.desc}
              </div>

              {/* If the service has an external link, display it here inside the modal */}
              {selectedService.link && (
                <a
                  href={selectedService.link}
                  className="service-modal-action-btn"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Visit External Link
                </a>
              )}
            </div>
            
          </div>
        </div>
      )}
    </section>
  );
};

export default Services;